export const blue = {
  blue: "#050A0F",
  blue1: "#0A1722",
  blue2: "#122A3F",
  blue3: "#26537E",
  blue4: "#2E6A9E",
  blue5: "#5193CD",
  blue6: "#AFCDE9",
};
